import { uniqBy } from 'lodash-es';
export default function getCanvasFonts(flatCanvas) {
    var fonts = uniqBy(flatCanvas
        .filter(function (item) { return item.className === 'Text'; })
        .map(function (item) { return item.style.fontFamily; }));
    fonts.sort();
    return fonts;
}
